"use strict";
exports.__esModule = true;
//# sourceMappingURL=message-log.type.js.map